<!-- <app-preloader></app-preloader> -->
<app-navbar *ngIf="!(location == '/error' || location == '/log-in' || location == '/sign-up')"></app-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="!(location == '/error' || location == '/log-in' || location == '/sign-up')"></app-footer>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>